export default __webpack_public_path__ + "static/media/single-choice-game-icon.1e1380a9.png";